import { render, staticRenderFns } from "./Provinces.vue?vue&type=template&id=91ca50ea&scoped=true"
import script from "./Provinces.vue?vue&type=script&lang=js"
export * from "./Provinces.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91ca50ea",
  null
  
)

export default component.exports